const Star = ({ width = 22, height = 22 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
  >
    <path
      d="M11.401 3.226C11.6446 2.72732 12.3554 2.72732 12.599 3.226L14.7659 7.66122C14.8631 7.86006 15.0526 7.99773 15.2717 8.02868L20.1595 8.71901C20.709 8.79662 20.9287 9.47255 20.5297 9.85837L16.9812 13.2898C16.8221 13.4436 16.7497 13.6664 16.788 13.8844L17.6418 18.7462C17.7378 19.2929 17.1629 19.7106 16.6726 19.4504L12.3126 17.1359C12.1171 17.0322 11.8829 17.0322 11.6874 17.1359L7.32737 19.4504C6.83714 19.7106 6.26217 19.2929 6.35818 18.7462L7.21203 13.8844C7.25031 13.6664 7.17794 13.4436 7.01885 13.2898L3.47033 9.85837C3.07135 9.47255 3.29097 8.79662 3.84053 8.71901L8.72829 8.02868C8.94742 7.99773 9.13691 7.86006 9.23406 7.66122L11.401 3.226Z"
      fill="#15B881"
    />
  </svg>
);

export default Star;

